module.exports = __webpack_public_path__ + "img/oceansunfish.39e0a480.png";